/**
 * Created by shubham on 16/4/18.
 */

import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { HttpService } from '../shared/services/http.service';
import { SessionHandler } from '../shared/services/session-handler.service';
import { MdDialog,MdDialogRef } from '@angular/material';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { CommonService } from '../shared/services/common.service';
import { APPCONFIG } from '../config';
import { DialogComponent } from '../dialog/dialog.component';
import {TranslateService} from 'ng2-translate';

@Component({
    template: require('./view-request.component.html')
})

export class ViewRequestComponent {
    data: any = [];
    dialogRef;
    userId: any;
    userEmail: any;
    id: any;
    ownerId: any;
    userDetails: any;
    isSystemAdmin:boolean = false;
    isBUManager:boolean = false;
    isApplicationManager:boolean = false;
    isRegionalAdmin:boolean = false;
    isServiceOwner:boolean = false;
    isTradePartner:boolean = false;
    isSubUser:boolean = false;
    showApproveReject:boolean = false;
    dynamicViewText: any;
    languageId: any;
    source: string = "partnersView";

    constructor(private router: Router, private route: ActivatedRoute, private httpService: HttpService, private sessionHandler:SessionHandler,
                private dialog: MdDialog, private commonService: CommonService, private translate: TranslateService) {

        this.languageId = this.sessionHandler.getItem('languageId');
        if(!this.languageId){
            this.languageId = "EN";
        }
        this.translate.use(this.languageId);

        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if(this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0){
            if(this.userDetails.roleCode.includes(APPCONFIG.systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.BUManager)) {
                this.isBUManager = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.applicationManager)) {
                this.isApplicationManager = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.serviceOwner)) {
                this.isServiceOwner = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.tradePartner)) {
                this.isTradePartner = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.subuser)) {
                this.isSubUser = true;
            }
        } else {
            this.httpService.noUserError();
        }
        this.route.queryParams.subscribe(params => {
            this.source = params['source'];
        });
        this.commonService.viewData.subscribe((value) => {
            this.data = value;
            if(this.data){
                if(this.data.userId_WPASS){
                    this.userId = this.data.userId_WPASS;
                } else{
                    this.translate.get('pending').subscribe((res: string) => {
                        this.userId = res;
                    });
                }
                this.id = this.data.id;
                this.ownerId = this.data.ownerId;
                this.userEmail = this.data.email;
            }
            if(this.isBUManager || this.isRegionalAdmin || this.isApplicationManager){
                this.commonService.viewDataFlag.subscribe((value) => {
                    if(value){
                        this.dynamicViewText = value;
                        if(this.dynamicViewText == 'subUsersView'){
                            this.showApproveReject = false;
                        } else if(this.dynamicViewText == 'partnersView'){

                            if(this.data['businessUnitWithApplicationAndRoles']){
                                for(let businessUnit of this.data['businessUnitWithApplicationAndRoles']){
                                    if(businessUnit.statusCode == "PENDING" && businessUnit.sessionUserManager){
                                        this.showApproveReject = true;
                                        this.data['businessUnitId'] = businessUnit.businessUnitId;
                                        break;
                                    } else{
                                        this.showApproveReject = false;
                                    }
                                }
                            } else{
                                this.showApproveReject = false;
                            }
                        } else {
                            this.showApproveReject = false;
                        }
                    }
                });
            } else if(this.isServiceOwner || this.isTradePartner){}
        });
    }

    selectedOption;
    public performAction(action){
        this.dialogRef = this.dialog.open(EmailActionDialogComponent);
        this.dialogRef.componentInstance.action = action;
        this.dialogRef.componentInstance.currentEmailAddress = this.userEmail;
        this.dialogRef.componentInstance.userId = this.id;
        this.dialogRef.afterClosed().subscribe(result => {
            this.data = result;
        });
    }

    setProfileAction(action, profileFormData){
        this.dialog.closeAll();
        if(action == 'changeEmail'){
            this.httpService.postRequest(profileFormData,'userOperationsApi/v1/emailUpdate').subscribe(
                res => { this.saveResponse(res, 'changeEmail'); },
                err => { this.httpService.onEnd(); }
            );
        }
    }

    public saveResponse(res, action){
        this.httpService.onEnd();
        if(res){
            if(action == 'changePassword'){
                this.dialogRef = this.dialog.open(DialogComponent);
                this.dialogRef.componentInstance.msg = 'Password updated successfully';
            } else if(action == 'changeEmail'){
                this.dialogRef = this.dialog.open(DialogComponent);
                this.dialogRef.componentInstance.msg = 'account_update_request_notify';
            }
        }
    }
}

@Component({
    providers:[ViewRequestComponent],
    template: require('./emailActionDialogComponent.html')
})
export class EmailActionDialogComponent implements OnInit {
    currentEmailAddress: any;
    action: any;
    userId: any;
    changeEmail: any;
    EmailActionForm: FormGroup;
    EmailDetails: any;
    emailPattern = APPCONFIG.emailPattern;

    constructor(public dialog: MdDialog, public dialogRef: MdDialogRef<DialogComponent>, private formBuilder: FormBuilder,
                private viewRequestComponent: ViewRequestComponent) {
        this.changeEmail = 'changeEmail';
    }

    buildForm() {
        this.EmailActionForm = this.formBuilder.group({
            emailGroup: this.formBuilder.group({
                currentEmailAddress: this.formBuilder.control({value: this.currentEmailAddress, disabled: true}, [Validators.required, Validators.pattern(this.emailPattern)]),
                email: this.formBuilder.control(null, [Validators.required, Validators.pattern(this.emailPattern)]),
                confirmEmail: this.formBuilder.control(null, [Validators.required, Validators.pattern(this.emailPattern)])
            },{validator: this.checkEmail})
        });
        this.EmailActionForm.valueChanges.subscribe(data => {
            let profileDetails = this.EmailActionForm.getRawValue();
            this.EmailDetails =  profileDetails.emailGroup;
            this.EmailDetails['id'] = this.userId;
        });
    }

    checkEmail(group: FormGroup) {
        if(group.get('email').value === group.get('confirmEmail').value){
            return null;
        } else{
            group.get('confirmEmail').setErrors({'incorrect': true});
            return {'mismatch': true};
        }
    }

    ngOnInit(): void {
        this.buildForm();
    }

    changeEmailAddress() {
        this.viewRequestComponent.setProfileAction(this.changeEmail, this.EmailDetails);
    }

    public closeDialog(){
        this.dialog.closeAll();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/viewRequest/view-request.component.ts